import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'booleanLabel',
  standalone: false
})
export class BooleanLabelPipe implements PipeTransform {

  constructor(private translateService: TranslateService) { }

  transform(value: boolean): string {
    return this.translateService.instant(`global.labels.boolean.${value}`);
  }

}
